import ChangePreferencesForm from './ChangePreferencesForm'

export default ChangePreferencesForm
